import { useContext } from "react";
import { AppContext } from "../App";
import passportImage from "../assets/passport.jpg";
import gumbo from "../assets/gumbo.jpeg";
import sade from "../assets/sade.jpeg";

const leaders = [
  {
    name: "Yusuph Juma Gumbo",
    image: gumbo,
    position: "Managing Director",
    detail: "Professional Engineer, 11 years general experience.",
  },
  {
    name: "Mganguzi Fadhil Sade",
    image: sade,
    position: "Technical Director",
    detail: "Professional Engineer, 11 years general experience.",
  },
];

export default function HomeTeamSection() {
  const appContext = useContext(AppContext);

  return (
    <section className="tgm-section tgm-home-team" data-aos="fade-up">
      <div className="container">
        <div className="tgm-home-section-top">
          <div>
            <h2>Meet the Pros</h2>
            <p>
              SMART TGM's leadership brings technical discipline, coordination,
              and construction experience into every project engagement.
            </p>
          </div>
          <button
            type="button"
            className="tgm-solid-btn"
            onClick={() =>
              appContext.navTo({ item: "about_us", subItem: "team" })
            }
          >
            View more
          </button>
        </div>

        <div className="tgm-team-preview-grid">
          {leaders.map((leader, index) => (
            <article
              className="tgm-team-card"
              key={leader.name}
              data-aos="fade-up"
              data-aos-delay={index * 80}
            >
              <div className="tgm-team-card-image">
                <img src={leader.image} alt={leader.name} />
              </div>
              <h3>{leader.name}</h3>
              <span>{leader.position}</span>
              <p>{leader.detail}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
